import { Component, OnInit } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { RateBoardService } from '../../services/rateboard.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FxRateObject } from '../models/symbol-model';

@Component({
    selector: 'fx-rates',
    templateUrl: './fx-rates.component.html'
})
export class FxRatesComponent implements OnInit {

    isLoading: boolean = true;
    systemError: boolean = false;
    fxRatesData: FxRateObject[] = [];
    asOfDate: string = '';
    displayedColumns: string[] = ['fromOneForeign', 'fromOneUSD'];
    fxRatesServiceErrorSub: any;
    fetchingFxRatesDataSub: any;
    fxRatesResponseSub: any;

    constructor(
        private translationService: PershingTranslationService,
        private rateBoardService: RateBoardService,
        public dialogRef: MatDialogRef<FxRatesComponent>) {
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-rateboard', 'node_modules/@pershing/nxi-ng-rateboard/lib');

        // Generic, http error e.g. 500.
        this.fxRatesServiceErrorSub = this.rateBoardService.fxRatesServiceError$.subscribe(error => {
            this.systemError = !!error && !!error.errorMessage;
            this.isLoading = false;
        });

        // loading
        this.fetchingFxRatesDataSub = this.rateBoardService.fetchingFxRatesData$.subscribe(fetching => {
            this.isLoading = !!fetching ? fetching : false;
        });

        this.fxRatesResponseSub = this.rateBoardService.fxRatesResponse$.subscribe(data => {
            if (!!data) {
                this.processFxRates(data);
            }
        });
    }

    processFxRates(data: FxRateObject[]) {
        this.fxRatesData = data.filter(item => { return item.symbol.indexOf('USD') === -1; });
        this.asOfDate = this.fxRatesData[0].convertedAsOfDate;
    }

    onClose() {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        if (this.fxRatesServiceErrorSub) {
            this.fxRatesServiceErrorSub.unsubscribe();
        }
        if (this.fetchingFxRatesDataSub) {
            this.fetchingFxRatesDataSub.unsubscribe();
        }
        if (this.fxRatesResponseSub) {
            this.fxRatesResponseSub.unsubscribe();
        }
    }

}
